import { createReducer } from "deox";

import { RequestResponse, RTP, SenderDataResponse } from "@APP/types";

import { clearRtpState, setRtpSuccess, setRtpTipAmount } from "../actions";

export interface RtpState {
  senderData: SenderDataResponse | null;
  rtpData: RequestResponse | null;
  rtp: RTP | null;
  payerTipAmount: string | null;
}

const defaultState: RtpState = {
  rtpData: null,
  senderData: null,
  rtp: null,
  payerTipAmount: null,
};

const rtpReducer = createReducer(defaultState, (handleAction) => [
  handleAction(setRtpSuccess, (state, { payload }) => ({
    ...state,
    rtpData: payload.rtpData,
    senderData: payload.senderData,
    rtp: payload.rtp,
  })),
  handleAction(setRtpTipAmount, (state, { payload }) => ({
    ...state,
    payerTipAmount: payload,
  })),
  handleAction(clearRtpState, (state) => ({
    ...state,
    ...defaultState,
  })),
]);

export default rtpReducer;
